import { NavLink, useLocation, useNavigate } from 'react-router';

import { ChevronLeftIcon } from '@heroicons/react/24/outline';

interface ITabsItems {
  id: number;
  label: string;
  to: string;
}

/**
 * Tabs component that displays a set of navigation items as clickable tabs.
 *
 * Each tab is defined by an internal array of objects containing an id, label, and target route.
 * The component uses NavLink from react-router to handle navigation and applies active styling
 * to the selected tab while using base styling for all tabs.
 *
 */

const Tabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const TabsItems: ITabsItems[] = [
    { id: 0, label: 'Krav', to: '/claims' },
    { id: 1, label: 'Startet', to: '/startet' },
    { id: 2, label: 'Sager', to: '/cases' },
  ];

  const baseClasses =
    'w-[150px] h-[34px] rounded-[20px] font-jostMedium text-lg duration-300';

  const activeClasses = 'bg-[#E9F8FF] !text-[#1F2B40] cursor-pointer';

  return (
    <div className="flex items-center justify-center gap-[150px] h-[70px] bg-[#1F2B40]">
      <div className="absolute left-8">
        {location.pathname === '/focus' && (
          <button
            className="relative p-1 w-[150px] h-[34px] rounded-[20px] font-jostMedium cursor-pointer bg-[#E9F8FF] text-[#1F2B40]"
            onClick={() => navigate(-1)}>
            <div className="absolute left-2 top-1/2 -translate-y-1/2">
              <ChevronLeftIcon className="size-5" />
            </div>
            <span className="absolute inset-0 flex items-center justify-center">
              Tilbage
            </span>
          </button>
        )}
      </div>
      {TabsItems.map(({ id, label, to }) => {
        return (
          <NavLink
            key={id}
            to={to}
            className={({ isActive }) =>
              isActive
                ? `${baseClasses} ${activeClasses}`
                : `${baseClasses} cursor-pointer text-white/90`
            }>
            <button className="w-[150px] h-[34px] rounded-[20px] font-jostMedium text-lg cursor-pointer">
              {label}
            </button>
          </NavLink>
        );
      })}
    </div>
  );
};

export default Tabs;
